import { render, staticRenderFns } from "./HomeworkContentDialogMobile.vue?vue&type=template&id=51a4e628"
import script from "./HomeworkContentDialogMobile.vue?vue&type=script&lang=js"
export * from "./HomeworkContentDialogMobile.vue?vue&type=script&lang=js"
import style0 from "./HomeworkContentDialogMobile.vue?vue&type=style&index=0&id=51a4e628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports